import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import css from './IconEdit.module.css';

const IconEdit = props => {
  const { rootClassName, className, pencilClassName } = props;
  const classes = classNames(rootClassName || css.root, className);
  return (
 <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
  <path d="M2.88257 4.82902L2.91016 18.2349C2.91233 19.2882 3.77591 20.1482 4.82923 20.1461L12.4897 20.1303L12.4858 18.2152L4.82528 18.2309L4.79769 4.82508L18.2036 4.79748L18.2193 12.458L20.1345 12.454L20.1187 4.79354C20.1165 3.74022 19.2529 2.88019 18.1996 2.88236L4.79375 2.90995C3.74043 2.91212 2.8804 3.7757 2.88257 4.82902Z" fill="#2F0F48"/>
  <path d="M9.58941 6.73065L7.67428 6.73459C7.14762 6.73567 6.71761 7.16746 6.71869 7.69412L6.72263 9.60925C6.72316 9.86779 6.82899 10.107 7.00173 10.2885L14.3422 17.5988L17.6007 14.3268L10.2603 7.01654C10.1706 6.92797 10.0644 6.85798 9.94761 6.81057C9.83085 6.76315 9.70587 6.73926 9.57985 6.74024L9.58941 6.73065ZM16.5971 19.8445C16.6858 19.933 16.7912 20.0033 16.9071 20.0511C17.0231 20.0989 17.1473 20.1234 17.2727 20.1231C17.3981 20.1228 17.5223 20.0979 17.638 20.0496C17.7537 20.0013 17.8588 19.9306 17.9472 19.8417L19.8584 17.9226C19.947 17.8338 20.0172 17.7285 20.065 17.6125C20.1128 17.4966 20.1373 17.3724 20.137 17.247C20.1368 17.1215 20.1118 16.9974 20.0635 16.8817C20.0152 16.7659 19.9446 16.6609 19.8556 16.5725L18.2724 14.9957L15.0138 18.2677L16.5971 19.8445Z" fill="#2F0F48"/>
</svg>
  );
};

IconEdit.defaultProps = {
  rootClassName: null,
  className: null,
  pencilClassName: null,
};

const { string } = PropTypes;

IconEdit.propTypes = {
  rootClassName: string,
  className: string,
  pencilClassName: string,
};

export default IconEdit;
